import React, { Fragment, Component } from "react";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Fieldset,
  Legend,
} from "reactstrap";
import { ConfirmAlert } from "../../../../helpers/ui/alert";
import Shimmer from "react-shimmer-effect";
import { FileInput, generateFormData } from "../../../../helpers/ui/FileInput";
import {
  AvForm,
  AvGroup,
  AvInput,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation";
import Select from "react-select";

import { Link, useHistory, Redirect } from "react-router-dom";

import apiResponse from "../../../../services/apiResponse";

import UpdateBloc from "./Blocs/UpdateBloc";
import { accessRole } from "../../../../helpers/access_role";

class IndexView extends Component {
  updateBloc = new UpdateBloc();

  constructor(props) {
    super(props);
    this.state = {
      dataForm: {
        nip: "",
        nama: "",
        unit_kerja: "",
        jabatan: "",
        tmt_jabatan: "",
        tgl_pensiun: "",
        golongan: "",
        tgl_lahir: "",
        jenis_kelamin: "",
        tmt_pensiun: "",
        usia: "",
        usia_pensiun: "",
        sisa_masa_kerja: "",
        posisi: "",
        emp_retired_sk_employe_uuid: "",
        documents_path: "",
      },
    };
  }

  submitData = async () => {
    if (this.state.dataForm.document.length > 0) {
      let formData = generateFormData(this.state.dataForm, "document");
      await this.updateBloc.fetchUpdate(formData);
    } else {
      await this.updateBloc.fetchUpdate(this.state.dataForm);
    }
  };

  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    this.setState({
      dataForm: {
        ...values,
      },
      confirm: true,
    });
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        this.submitData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  componentDidMount() {
    this.updateBloc.updateChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            loading: false,
            success: true,
          });
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });

    this.updateBloc.detailChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            // load to form
            this.setState({
              dataForm: {
                uuid: response.emp_retired_sk_uuid,
                emp_retired_sk_employe_uuid:
                  response.emp_retired_sk_employe_uuid,
                nip: response.employee_nip,
                nama: response.employee_name,
                unit_kerja: response.employee_work_unit_name,
                jabatan: response.employee_position_name,
                tgl_pensiun: response.employee_date_of_pension,
                tmt_pensiun: response.emp_retired_sk_date_tmt,
                usia: response.employee_age,
                usia_pensiun: response.employee_age_retired,
                sisa_masa_kerja: response.employee_work_age,
                posisi: response.employee_position_name,
                no_bkn: response.emp_retired_sk_bkn_number,
                tgl_bkn: response.emp_retired_sk_bkn_date,
                no_sk_pensiun: response.emp_retired_sk_number,
                documents_path: response.documents_path,
              },
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    const search = window.location.search;
    const queryParams = new URLSearchParams(search);
    this.updateBloc.fetchDetail({ uuid: queryParams.get("uuid") });
  }

  render() {
    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col className="col-12">
              <Card className="">
                <CardBody>
                  <CardTitle>Edit SK Pemberhentian</CardTitle>
                  <CardSubtitle className="mb-3">
                    Setiap isian yang bertanda (
                    <span className="text-danger">*</span>) adalah wajib diisi.
                  </CardSubtitle>
                  <hr />

                  <AvForm
                    className="needs-validation"
                    onValidSubmit={(e, values) =>
                      this.handlerOnSubmit(e, values)
                    }
                  >
                    <AvField
                      name="uuid"
                      type="hidden"
                      id="uuid"
                      value={this.state.dataForm.uuid}
                    />

                    <AvField
                      name="retired_employee_uuid"
                      type="hidden"
                      id="uuid"
                      value={this.state.dataForm.emp_retired_sk_employe_uuid}
                    />

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        NIP
                      </label>
                      <Col md="9">
                        <AvField
                          placeholder=""
                          name="nip"
                          id="nip"
                          readonly="readonly"
                          type="text"
                          className="form-control"
                          value={this.state.dataForm.nip}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Nama
                      </label>
                      <Col md="9">
                        <AvField
                          placeholder=""
                          name="nama"
                          id="nama"
                          readonly="readonly"
                          type="text"
                          className="form-control"
                          value={this.state.dataForm.nama}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Posisi
                      </label>
                      <Col md="9">
                        <AvField
                          placeholder=""
                          name="posisi"
                          id="posisi"
                          readonly="readonly"
                          type="text"
                          className="form-control"
                          value={this.state.dataForm.posisi}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Unit Kerja
                      </label>
                      <Col md="9">
                        <AvField
                          placeholder=""
                          name="unit_kerja"
                          id="unit_kerja"
                          readonly="readonly"
                          type="text"
                          className="form-control"
                          value={this.state.dataForm.unit_kerja}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Tanggal Pemberhentian
                      </label>
                      <Col md="9">
                        <AvField
                          placeholder=""
                          name="tgl_pensiun"
                          id="tgl_pensiun"
                          readonly="readonly"
                          className="form-control"
                          value={this.state.dataForm.tgl_pensiun}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Sisa Masa Kerja
                      </label>
                      <Col md="9">
                        <AvField
                          placeholder=""
                          name="masa_kerja"
                          id="masa_kerja"
                          readonly="readonly"
                          type="form-control"
                          className="form-control"
                          value={this.state.dataForm.sisa_masa_kerja}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        TMT Pemberhentian <span className="text-danger">*</span>
                      </label>
                      <Col md="9">
                        <AvField
                          placeholder="TMT Pensiun"
                          name="tmt_pensiun"
                          id="tmt_pensiun"
                          type="date"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          value={this.state.dataForm.tmt_pensiun}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        No BKN <span className="text-danger">*</span>
                      </label>
                      <Col md="9">
                        <AvField
                          placeholder="Nomor BKN"
                          name="no_bkn"
                          id="no_bkn"
                          type="form-control"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          value={this.state.dataForm.no_bkn}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Tanggal BKN <span className="text-danger">*</span>
                      </label>
                      <Col md="9">
                        <AvField
                          placeholder="Tanggal BKN"
                          name="tgl_bkn"
                          id="tgl_bkn"
                          type="date"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          value={this.state.dataForm.tgl_bkn}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Nomor SK Pemberhentian{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <Col md="9">
                        <AvField
                          placeholder="Nomor SK Pensiun"
                          name="no_sk_pensiun"
                          id="no_sk_pensiun"
                          type="form-control"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          value={this.state.dataForm.no_sk_pensiun}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        File SK <span className="text-danger">*</span>
                      </label>
                      <Col md="9">
                        <FileInput name="document" />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label className="col-md-3">Dokumen SK Terupload</label>
                      <Col md="9">
                        {this.state.dataForm ? (
                          <>
                            {this.state.dataForm.documents_path !== "" ? (
                              <a
                                target="_blank"
                                rel="noreferrer"
                                class="btn btn-sm btn-primary"
                                href={this.state.dataForm.documents_path}
                              >
                                <i className="uil-file-download"></i> Download
                                File
                              </a>
                            ) : (
                              "Tidak ada dokumen"
                            )}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 68, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col md="3"></Col>
                      <Col md="9">
                        <Link to="/kepegawaian/pensiunsk.html">
                          <Button color="danger">
                            <i className="uil-arrow-left"></i> Kembali
                          </Button>
                        </Link>{" "}
                        <Button color="success" type="submit">
                          <i className="uil-arrow-up-right"></i> Simpan Data
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin akan menyimpan data ini?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil disimpan"
          failedTitle="Gagal!"
          failedInfo="Data gagal disimpan"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.redirect ? (
          <Redirect to="/kepegawaian/pensiunsk.html" />
        ) : null}
      </Fragment>
    );
  }
}

export default IndexView;
